import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const QuantityButton = ({
	count,
	increaseCount,
	reduceCount,
}) => (
  <div className="button-quantity">
    <span className="button-quantity__sign" onClick={reduceCount}>-</span>
    <span className="button-quantity__counter">{count}</span>
    <span className="button-quantity__sign" onClick={increaseCount}>+</span>
  </div>
);

QuantityButton.propTypes = {
  count: PropTypes.number.isRequired,
  increaseCount: PropTypes.func.isRequired,
  reduceCount: PropTypes.func.isRequired,
};

export default QuantityButton;



// WEBPACK FOOTER //
// ./src/components/ui/Buttons/QuantityButton/index.js